/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Collapse } from 'reactstrap';

import useApi from 'hooks/useApi';
import { getReadDocument } from 'redux/actions/documentActions';

import { ReactComponent as FolderIcon } from 'assets/icon-folder.svg';
import { ReactComponent as CaretDownIcon } from 'assets/icon-angle-down.svg';
import { ReactComponent as CaretUpIcon } from 'assets/icon-angle-up.svg';

import { colors } from 'shared/defaultTheme';

import { TreeWrapper, ItemDataWrapper } from '../styles';

const TreeFolder = () => {
  const { customAreaApi } = useApi();
  const dispatch = useDispatch();
  const { cusNavId, clientId, mail } = useSelector((state) => state.auth);
  const { currentClient } = useSelector((state) => state.clientState);
  const { readDocument } = useSelector((state) => state.document);
  const [folders, setFolders] = useState([]);
  const [folderRoot, setFolderRoot] = useState({});

  const [, getItemsByClient] = customAreaApi(
    {
      url: `${window.API_V1}/cli/items/${cusNavId}/${encodeURIComponent(mail)}/search/all`,
      method: 'POST',
    },
    { manual: true }
  );

  const getItems = async () => {
    try {
      const filters = [
        {
          model: 'PathItem',
          field: 'ClientId',
          filter: [clientId || currentClient.clientId],
        },
      ];

      const {
        data: { data: itemsData },
      } = await getItemsByClient({
        data: {
          filters,
          reduce: {
            limit: 1000,
            skip: 0,
          },
        },
      });
      const data = itemsData || [];
      setFolderRoot(data.find((x) => !x.visible && !x.parentId));
      setFolders(
        data
          ? data
              .map((item) => (item.hasChild ? { ...item, isOpen: false } : item))
              .filter((x) => !x.isFile)
          : []
      );
    } catch (ex) {
      console.error('Error getting custom items: ', ex);
    }
  };

  useEffect(() => {
    if (currentClient || clientId) {
      getItems();
    }
  }, [currentClient]);

  const getCaretIcon = (item) => {
    if (item.hasChild) {
      return item.isOpen ? <CaretUpIcon className="caret" /> : <CaretDownIcon className="caret" />;
    }
    return null;
  };

  const getCurrentItem = (data, itemId) => {
    setFolders(
      folders.map((item) => (item.id === itemId ? { ...item, isOpen: !item.isOpen } : item))
    );
    dispatch(getReadDocument(data));
  };

  const ItemTree = ({ listItem, level }) => {
    return listItem
      ? listItem.map((item) =>
          item.id ? (
            <React.Fragment key={item.id}>
              <ItemDataWrapper
                className="item-data-container"
                level={level}
                onClick={() => getCurrentItem(item, item.id)}
                selectedColor={readDocument?.id === item.id ? colors.whiteSmoke : 'transparent'}
              >
                <div id={`toggle-folder${item.id}`} className="info-container">
                  {item.isOpen && item.hasChild ? (
                    <FolderIcon className="folder-icon" />
                  ) : (
                    <FolderIcon className="folder-icon" />
                  )}
                  <span className="text-file">{item.name}</span>
                </div>
                {getCaretIcon(item)}
              </ItemDataWrapper>
              <Collapse isOpen={item.isOpen}>
                {folders?.some((currentItem) => currentItem.parentId === item.id) ? (
                  <ItemTree
                    listItem={folders?.filter((currentItem) => currentItem.parentId === item.id)}
                    level={level + 1}
                  />
                ) : null}
              </Collapse>
            </React.Fragment>
          ) : null
        )
      : null;
  };

  return (
    <TreeWrapper>
      <div className="item-tree-container">
        <ItemTree listItem={folders?.filter((item) => item.parentId === folderRoot.id)} level={1} />
      </div>
    </TreeWrapper>
  );
};

TreeFolder.propTypes = {};

export default TreeFolder;
